import React, { useEffect, useState } from "react";
import { Layout, Upload, Button, message, Popconfirm, Row, Col } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import SiderComponent from "../components/SiderComponent";
import HeaderComponent from "../components/HeaderComponent";
import greenfeeDealsApi from "../api/greenfeeDeals";

const { Content } = Layout;
let uploadWarningShown = false;

const SuperAdminImages = () => {
  const sessionBnd = localStorage.getItem("sessionBnd");
  const [uploading, setUploading] = useState(false);
  const headers = { headers: { Authorization: `Bearer ${sessionBnd}` } };

  const [images, setImages] = useState([]);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const res = await greenfeeDealsApi.get("/deal-images", headers);
      setImages(res.data.data);
    } catch (error) {
      message.error("Failed to load images");
    }
  };

  const handleUpload = async ({ file }) => {
    if (images.length >= 10) {
      message.warning("Maximum 10 images allowed");
      return;
    }

    const isValidSize = file.size / 1024 / 1024 < 1;
    if (!isValidSize) {
      message.error("Image must be < 1MB");
      return;
    }

    const formData = new FormData();
    formData.append("dealImage", file);

    try {
      setUploading(true); // ⬅️ Show loader
      await greenfeeDealsApi.post("/deal-images/upload", formData, headers);
      message.success("Image uploaded!");
      fetchImages();
    } catch (error) {
      message.error(error.response?.data?.message || "Upload failed");
    } finally {
      setUploading(false); // ⬅️ Hide loader
    }
  };

  const handleDelete = async (id) => {
    try {
      await greenfeeDealsApi.delete(`/deal-images/${id}`, headers);
      message.success("Image deleted");
      fetchImages();
    } catch (error) {
      message.error("Delete failed");
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SiderComponent />
      <Layout>
        <HeaderComponent />
        <Content style={{ background: "#f8f8f8", padding: 30 }}>
          <h2>Deals Images Management</h2>

          <Upload
            customRequest={handleUpload}
            showUploadList={false}
            multiple
            accept="image/*"
            beforeUpload={(file, fileList) => {
              const remaining = 10 - images.length;

              // reset when starting new selection
              if (!uploadWarningShown) {
                // allow first call of this upload batch
              }

              if (remaining <= 0) {
                if (!uploadWarningShown) {
                  message.warning(
                    "You already have 10 images. Delete one to upload."
                  );
                  uploadWarningShown = true;

                  setTimeout(() => {
                    uploadWarningShown = false;
                  }, 500);
                }
                return Upload.LIST_IGNORE;
              }

              if (fileList.length > remaining) {
                if (!uploadWarningShown) {
                  message.warning(
                    `You can upload only ${remaining} more image(s).`
                  );
                  uploadWarningShown = true;

                  setTimeout(() => {
                    uploadWarningShown = false;
                  }, 500);
                }
                return Upload.LIST_IGNORE;
              }

              return true;
            }}
          >
            <Button
              type="primary"
              icon={<UploadOutlined />}
              disabled={images.length >= 10 || uploading}
              loading={uploading} // ⬅️ loader added
            >
              Upload Images (Max 10)
            </Button>
          </Upload>

          <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
            {images.map((img) => (
              <Col xs={24} sm={12} md={8} lg={6} key={img._id}>
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: 10,
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    src={`https://greenfeedeals2.s3.eu-central-1.amazonaws.com/${img.image}`}
                    alt=""
                    style={{ width: "100%" }}
                  />

                  <Popconfirm
                    title="Delete this image?"
                    onConfirm={() => handleDelete(img._id)}
                  >
                    <Button
                      icon={<DeleteOutlined />}
                      danger
                      size="small"
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background: "white",
                      }}
                    />
                  </Popconfirm>
                </div>
              </Col>
            ))}
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SuperAdminImages;
